import { useAdminUpdate } from '@reapitform/hooks'
import { AdminRecipientField, AdminRecipientFieldPayload } from '../types'

/** Updates a recipient field (`PUT /recipient-cards/{cardRef}/fields/{fieldRef}`). */
export const useUpdateAdminRecipientField = (recipientCardReferenceID: string, recipientFieldReferenceID: string) =>
  useAdminUpdate<AdminRecipientFieldPayload, AdminRecipientField>({
    path: `/api/recipient-cards/${recipientCardReferenceID}/fields/${recipientFieldReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the recipient field',
    successMessage: 'Recipient field updated',
  })
